import { render, staticRenderFns } from "./taskmenu.vue?vue&type=template&id=3ef29168&scoped=true&"
import script from "./taskmenu.vue?vue&type=script&lang=js&"
export * from "./taskmenu.vue?vue&type=script&lang=js&"
import style0 from "./taskmenu.vue?vue&type=style&index=0&id=3ef29168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef29168",
  null
  
)

export default component.exports